import React, { useEffect, useState } from "react";
import HeaderSection from "../child_components/HeaderSection";
import Pagination from "../reusable_components/Pagination.jsx";
import { findQuotes, updateQuoteStatus } from "../api/partstechApi.js";
import { tableCol, tableHeader } from "../utils/style.js";
import { FaRegEye } from "react-icons/fa";
import PartstechQuoteDetails from "../child_components/PartstechQuoteDetails";
// import { toast } from "react-toastify";
import moment from "moment";

const PartstechQuotes = () => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  // const [selectedRows, setSelectedRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  // const [approvalStatus, setApprovalStatus] = useState("");
  const [reloadTable, setReloadTable] = useState(false)

  // const handleRowSelect = (rowIndex) => {
  //   const updatedFiles = [...files];
  //   const rowId = updatedFiles[rowIndex].id;

  //   updatedFiles[rowIndex].selected = !updatedFiles[rowIndex].selected;

  //   setSelectedRows((prevSelectedRows) => {
  //     if (updatedFiles[rowIndex].selected) {
  //       return [...prevSelectedRows, rowId];
  //     } else {
  //       return prevSelectedRows.filter((id) => id !== rowId);
  //     }
  //   });

  //   setFiles(updatedFiles);
  // };

  const fetchFiles = async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await findQuotes(page);
      response?.data?.data?.forEach((record) => {
        const age = moment().diff(moment(record.createdAt), "days");
        record.expireAt = 120 - age;
      })
      setFiles(response.data?.data || []);
      setTotalPages(response.data?.pagination?.totalPages || 1);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFiles(currentPage);
    // setSelectedRows([]);
    setFiles((prevFiles) =>
      prevFiles.map((file) => ({ ...file, selected: false }))
    );
  }, [currentPage, reloadTable]);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const columns = [
    { name: "PO Number", width: "20%" },
    { name: "Type", width: "15%" },
    // { name: "Status", width: "15%" },
    { name: "Is Ordered", width: "15%" },
    { name: "Created At", width: "15%" },
    { name: "Days left", width: "15%" },
    { name: "Action", width: "5%" },
  ];

  const handleOpenModal = (data) => {
    setModalData(data);
    setIsModalOpen(true);
  };

  // const handleUpdateStatus = async () => {
  //   try {
  //     if (approvalStatus === "") {
  //       return toast.error("Please select status", { autoClose: 3000 });
  //     }
  //     const data = { ids: selectedRows, status: approvalStatus };
  //     const result = await updateQuoteStatus(data);
  //     if (result.status === 200) {
  //       setSelectedRows([]);
  //       toast.success("Statuse Updated", { autoClose: 3000 });
  //       setReloadTable((prev) => !prev);
  //     } else {
  //       return toast.error("Couldn't update status", { autoClose: 3000 });
  //     }
  //   } catch (err) {
  //     toast.error("Failed to update", { autoClose: 3000 });
  //   }
  // };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalData(null);
  };

  if (loading) return <div>Loading data...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      <div className="flex justify-between items-center mb-3 text-center">
        <HeaderSection title={"Quotations"} />
        {/* <select
          id="status"
          name="status"
          className="block ml-auto mr-3 p-1 border border-black rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-400 text-sm bg-gray-100"
          onChange={(e) => setApprovalStatus(e.target.value)}
        >
          <option value="">--select status--</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
        </select> */}
        {/* <button
          disabled={selectedRows.length !== 1}
          onClick={handleUpdateStatus}
          className={`px-3 py-1 text-sm rounded-md 
      ${selectedRows.length !== 1
              ? "bg-blue-300 text-white cursor-not-allowed"
              : "bg-blue-500 text-white hover:scale-110 transform transition-all duration-200"
            }`}
        >
          Save
        </button> */}
      </div>
      <div className="overflow-hidden">
        <div className="overflow-auto">
          <table className="table-auto w-full text-center">
            <thead>
              <tr>
                {columns.map((col, idx) => {
                  return (
                    <th
                      key={idx}
                      className={tableHeader}
                      style={{ width: col.width }}
                    >
                      {col.name}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {files.map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  // className={row.selected ? "bg-green-100" : ""}
                  className="py-6"
                  // onClick={() => handleRowSelect(rowIndex)}
                >
                  <td className={tableCol}>
                    {row.poNumber}
                  </td>
                  <td className={tableCol}>
                    {row.orderType ? row.orderType.charAt(0).toUpperCase() + row.orderType.slice(1) : ""}
                  </td>
                  {/* <td className={tableCol}>
                    {row.status ? row.status.charAt(0).toUpperCase() + row.status.slice(1) : ""}
                  </td> */}
                  <td className={tableCol}>
                    {row.isOrderPlaced === true ? "Yes" : "No"}
                  </td>
                  <td className={tableCol}>
                    {row.createdAt}
                  </td>
                  <td className={tableCol}>
                    {row.expireAt}
                  </td>
                  <td className={tableCol}>
                    <FaRegEye
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenModal(row);
                      }}
                      className="cursor-pointer text-gray-600 hover:text-blue-500 hover:scale-125 transition-transform duration-200"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
      {isModalOpen &&
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-3/4">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">Quotation</h2>
              <button
                onClick={handleCloseModal}
                className="text-red-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>
            <PartstechQuoteDetails data={modalData} setReloadTable={setReloadTable} setIsModalOpen={setIsModalOpen}/>
          </div>
        </div>}
    </div>
  );
};

export default PartstechQuotes;
